angular.module('cvsApp').service('loginAuthenticationService', ['networkService', 'xdrService', 'configManager', 'loginAuthenticationModel', 'cvsAppData', function(NS, XS, CM, LAM, CAD ) {

    function authUser() {
        this.authUser = function(req, callBackSuccess) {
            //get url
            var tokenId = CAD.getTokenId();
            var tokenType = CAD.getTokenType();
            var apikey = CAD.getApiKey();
            var url = CM.getAPIUrlWithOtherInfo('AUTHENTICATION');
            // url='https://sit2fast.cvsspecialty.com/api/specialty/loginService/authenticate/1.0'
            if (url === "URL_ERROR") {

            } else {

                //var url = cvsUtility.updateQueryParam(url, 'appName', 'Portal');
                var request = {
                    url: url,
                    header: {
                        'Content-Type': 'application/xml',
                        'accept': 'application/xml'
                    },
                    data: requestBody(req),
                    onSuccess: callBackSuccess
                }
                if (cvsUtility.getIEVersion() <= 9) {
                    XS.makeRequest(url, "", xdrSuccess);

                    function xdrSuccess(data) {
                        LAM.setResponse(data);
                        callBackSuccess(LAM.getResponse());
                    }
                } else {
                    // console.log("reqqqqqq", request);
                    var promise = NS.post(request);
                    promise.then(function(data, c, d) {

                        LAM.setResponse(data.data);
                        callBackSuccess(LAM.getResponse());
                        //send message to parent
                        // if (!CAD.isGuestRefill()) {
                        //     cvsUtility.sendPostMessage("SESSION-ALIVE", "loginAuthentication");
                        // }
                    }, function(reason) {
                        callBackSuccess(NS.httpError(reason));
                    });
                }
            }

        }

        var requestBody = function(req) {
            var tokenId = CAD.getTokenId();
            var tokenType = CAD.getTokenType();
            var apikey = CAD.getApiKey();
            var hashkey = CAD.getHashKey();
            var timestamp = CAD.getTimeStamp();
            var x2js = new X2JS();
            var reqStr = "";
            reqStr = "<authenticateRequest>"+
                "<header>"+
                "<serviceContext>"+
                "<appName>SPL_APP</appName>"+
            "<lineOfBusiness>Specialty</lineOfBusiness>"+
            "<channelName>Web_MobAnd</channelName>"+
            "</serviceContext>"+
            "<securityContext>"+
            "<apiKey>"+apikey+"</apiKey>"+
            "<hashKey>"+hashkey+"</hashKey>"+
                "<timeStamp>"+timestamp+"</timeStamp>"+
                "</securityContext>"+
                "</header>"+
                "<details>"+
                "<username>"+req.username+"</username>"+
            "<password><![CDATA["+req.password+"]]></password>"+
            "<sessionStartTimestamp></sessionStartTimestamp>"+
            "<ipAddress></ipAddress>"+
            "</details>"+
            "</authenticateRequest>"

            /*return x2js.json2xml_str({
                "updatePasswordRequest": {
                    "header": {
                        "serviceContext": {
                            "appName": cvsUtility.queryMap.mobileAppStyle ? 'SPL_APP' : 'SPL_WEB',
                            "lineOfBusiness": "Specialty",
                            "channelName": cvsUtility.queryMap.channel
                        },
                        "securityContext": {
                            "apiKey": apikey,
                            "hashkey": hashkey,
                            "timestamp": timestamp
                        }
                    },
                    "details": {                        
                        "username": req.username,
                        "password" : req.password
                    }                              
                }
            });
*/
            return reqStr;
        }

    }

    return new authUser();
}]);